<template>
  <mobialisCard>
    <div class="row">
      <div class="flex-column pl-3">
        <div class="icon-wrapper img primary-fill-svg">
          <inline-svg class="icon" :src="require('@/assets/icon-entry-car.svg')" />
        </div>
      </div>
      <div class="col">
        <h2 data-cy="heading" class="my-2 heading">
          {{ $t('message.trade.cta.title') }}
        </h2>
        <p class="mb-4 mt-2" data-cy="bodyCopy">{{ $t('message.trade.cta.heading') }}</p>
        <MobialisButton data-cy="applyNow" @click="btnClick" width="w-auto">{{
          $t('message.trade.cta.button')
        }}</MobialisButton>
      </div>
    </div>
  </mobialisCard>
</template>

<script>
import { mapGetters } from 'vuex';
import { AVRProducts } from '@/utils/enums';

export default {
  name: 'ApplyNow',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getProductHomeRoute']),
  },
  methods: {
    btnClick() {
      this.$router.push({ path: this.getProductHomeRoute(AVRProducts.TRADE) });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';

h2.heading {
  font-size: 20px;
  font-weight: bold;
  line-height: 25px;
  @media (max-width: $breakpoint-mobile) {
    font-size: 18px;
    line-height: 22.5px;
  }
}
p {
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #4b5863;
}

.icon-wrapper {
  height: 48px;
  width: 48px;
  background-color: $primary-light-background;
  border-radius: 50%;
  align-items: center;
  display: flex;
  .icon {
    display: block;
    margin: 0 auto;
  }
}
</style>
